// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-suspense-spin-loading {
  height: 100vh !important;
  max-height: 100vh !important;
  background: #fff;
}
.login-contant {
  position: relative;
  min-height: 100vh;
  height: 100%;
  overflow-x: hidden;
  /* form表单样式调整 */
}
.login-contant .login-container {
  overflow: hidden;
  background: rgba(255, 255, 255);
  box-sizing: border-box;
}
.login-contant .login-container .login-from {
  /* 忘记用户名、忘记密码、游客登录 */
}
.login-contant .login-container .login-from .ant-form-item-label > label {
  font-family: 'geomanistLight', 'Hiragino Sans GB', 'Microsoft Yahei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 600;
  color: #666;
}
.login-contant .login-container .login-from .infoButton {
  text-align: center;
}
.login-contant .login-container .login-from .infoButton .infoComButton {
  color: #868686;
  padding: 0px !important;
  cursor: pointer;
  z-index: 999;
}
.login-contant .login-container .login-from .infoButton .line {
  height: 12px;
  display: inline-block;
  width: 1px;
  background: rgba(0, 0, 0, 0.45);
  position: relative;
  top: 2px;
  margin: 0px 5px;
}
@media (min-width: 0) and (max-width: 640px) {
  .login-contant .login-container {
    height: calc(100vh - 50px);
    min-height: 550px;
    overflow-x: hidden;
  }
  .login-contant .login-container .login-from {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
  }
  .login-contant .login-container .login-from .infoButton {
    margin-top: -14px;
  }
  .login-contant .login-container .login-from .login-submit-btn {
    margin-top: 20px;
    margin-bottom: 12px;
  }
  .login-contant .login-container .login-from .login-footer {
    display: none;
  }
  .login-contant .login-background {
    display: none;
  }
}
@media (min-width: 640px) {
  .login-contant {
    position: relative;
    /* 轮播图样式调整 */
  }
  .login-contant .login-container {
    z-index: 500;
    position: absolute;
    right: 0;
    top: 50px;
    bottom: 0px;
    opacity: 0.9;
    width: 40%;
    min-width: 300px;
    min-height: 580px;
    max-height: calc(100vh - 50px);
    padding: 80px 15px 0px;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    opacity: 1;
  }
  .login-contant .login-container .login-from {
    position: relative;
    width: 48%;
    min-width: 250px;
    margin: auto;
  }
  .login-contant .login-container .login-from .ant-row {
    justify-content: center;
  }
  .login-contant .login-container .login-from .login-submit-btn {
    margin-top: 40px;
    margin-bottom: 32px;
  }
  .login-contant .login-container .login-from .infoButton {
    position: absolute;
    top: 270px;
  }
  .login-contant .login-container .login-from .login-footer {
    margin-top: 32px;
    color: rgba(86, 86, 86);
    width: 100% !important;
    text-align: center;
    font-size: 14px;
  }
  .login-contant .login-background {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    min-height: 580px;
    height: calc(100vh - 50px);
  }
  .login-contant .login-background .login-bg-img {
    min-height: 580px;
    height: calc(100vh - 50px);
  }
  .login-contant .login-background .ant-carousel .slick-dots li {
    width: 0px !important;
    height: 0px !important;
    border: 5px solid white;
    border-radius: 100%;
  }
  .login-contant .login-background .ant-carousel .slick-dots .slick-active {
    border: 5px solid #e8aa0d;
  }
}
.mfa-content .mfa-form .ant-form-item {
  margin-bottom: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/index.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4BAAA;EACA,gBAAA;AACF;AACA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAe;AACjB;AANA;EAOI,gBAAA;EACA,+BAAA;EACA,sBAAA;AAEJ;AAXA;EAaE,oBAAoB;AACtB;AAdA;EAYQ,uGAAA;EACA,gBAAA;EACA,WAAA;AAKR;AAnBA;EAkBQ,kBAAA;AAIR;AAtBA;EAoBU,cAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAKV;AA5BA;EA0BU,YAAA;EACA,qBAAA;EACA,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AAKV;AAEA;EACE;IAEI,0BAAA;IACA,iBAAA;IACA,kBAAA;EADJ;EAHA;IAMM,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,UAAA;EAAN;EAVA;IAYQ,iBAAA;EACR;EAbA;IAeQ,gBAAA;IACA,mBAAA;EACR;EAjBA;IAmBQ,aAAA;EACR;EApBA;IAwBI,aAAA;EADJ;AACF;AAKA;EACE;IACE,kBAAA;IAHA,YAAY;EACd;EACA;IAGI,YAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,gBAAA;IACA,iBAAA;IACA,8BAAA;IACA,sBAAA;IACA,4BAAA;IACA,+BAAA;IACA,UAAA;EADJ;EAfA;IAkBM,kBAAA;IACA,UAAA;IACA,gBAAA;IACA,YAAA;EAAN;EArBA;IAuBQ,uBAAA;EACR;EAxBA;IA0BQ,gBAAA;IACA,mBAAA;EACR;EA5BA;IA8BQ,kBAAA;IACA,UAAA;EACR;EAhCA;IAkCQ,gBAAA;IACA,uBAAA;IACA,sBAAA;IACA,kBAAA;IACA,eAAA;EACR;EAvCA;IA4CI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,iBAAA;IACA,0BAAA;EAFJ;EA/CA;IAoDM,iBAAA;IACA,0BAAA;EAFN;EAnDA;IA0DU,qBAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EAJV;EAzDA;IAgEU,yBAAA;EAJV;AACF;AAWA;EAGM,mBAAA;AAXN","sourcesContent":[".login-suspense-spin-loading {\n  height: 100vh !important;\n  max-height: 100vh !important;\n  background: #fff;\n}\n.login-contant {\n  position: relative;\n  min-height: 100vh;\n  height: 100%;\n  overflow-x: hidden;\n  /* form表单样式调整 */\n  .login-container {\n    overflow: hidden;\n    background: rgba(255, 255, 255);\n    box-sizing: border-box;\n    .login-from {\n      .ant-form-item-label > label {\n        font-family: 'geomanistLight', 'Hiragino Sans GB', 'Microsoft Yahei', 'WenQuanYi Micro Hei', sans-serif;\n        font-weight: 600;\n        color: #666;\n      }\n      /* 忘记用户名、忘记密码、游客登录 */\n      .infoButton {\n        text-align: center;\n        .infoComButton {\n          color: #868686;\n          padding: 0px !important;\n          cursor: pointer;\n          z-index: 999;\n        }\n        .line {\n          height: 12px;\n          display: inline-block;\n          width: 1px;\n          background: rgba(0, 0, 0, 0.45);\n          position: relative;\n          top: 2px;\n          margin: 0px 5px;\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 0) and (max-width: 640px) {\n  .login-contant {\n    .login-container {\n      height: calc(100vh - 50px);\n      min-height: 550px;\n      overflow-x: hidden;\n      .login-from {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 90%;\n        .infoButton {\n          margin-top: -14px;\n        }\n        .login-submit-btn {\n          margin-top: 20px;\n          margin-bottom: 12px;\n        }\n        .login-footer {\n          display: none;\n        }\n      }\n    }\n    .login-background {\n      display: none;\n    }\n  }\n}\n\n@media (min-width: 640px) {\n  .login-contant {\n    position: relative;\n    .login-container {\n      z-index: 500;\n      position: absolute;\n      right: 0;\n      top: 50px;\n      bottom: 0px;\n      opacity: 0.9;\n      width: 40%;\n      min-width: 300px;\n      min-height: 580px;\n      max-height: calc(100vh - 50px);\n      padding: 80px 15px 0px;\n      border-top-left-radius: 40px;\n      border-bottom-left-radius: 40px;\n      opacity: 1;\n      .login-from {\n        position: relative;\n        width: 48%;\n        min-width: 250px;\n        margin: auto;\n        .ant-row {\n          justify-content: center;\n        }\n        .login-submit-btn {\n          margin-top: 40px;\n          margin-bottom: 32px;\n        }\n        .infoButton {\n          position: absolute;\n          top: 270px;\n        }\n        .login-footer {\n          margin-top: 32px;\n          color: rgba(86, 86, 86);\n          width: 100% !important;\n          text-align: center;\n          font-size: 14px;\n        }\n      }\n    }\n    /* 轮播图样式调整 */\n    .login-background {\n      position: absolute;\n      top: 50px;\n      left: 0;\n      width: 100%;\n      min-height: 580px;\n      height: calc(100vh - 50px);\n      .login-bg-img {\n        // width: 100%;\n        min-height: 580px;\n        height: calc(100vh - 50px);\n      }\n      .ant-carousel {\n        .slick-dots {\n          li {\n            width: 0px !important;\n            height: 0px !important;\n            border: 5px solid white;\n            border-radius: 100%;\n          }\n          .slick-active {\n            border: 5px solid #e8aa0d;\n          }\n        }\n      }\n    }\n  }\n}\n\n.mfa-content {\n  .mfa-form {\n    .ant-form-item {\n      margin-bottom: 40px;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
